export default "__VITE_ASSET__BRNPeQaF__"